import Select from 'react-select-2';
import type { FunctionComponent } from 'react';

import { selectOptionFactory } from '../../../../utils';
import FormLabel from '../../../generic/Forms/FormLabel';
import type { SelectOption } from '../../../../types';

import type { TrackerExportType } from './useTrackerExportPicker';

type ModalIssueExportTrackerPickerProps = {
  trackerType: TrackerExportType;
  isDisabled: boolean;
  onTrackerTypeChange: (trackerType: TrackerExportType) => void;
};

const OPTIONS: Array<SelectOption<string>> = [
  selectOptionFactory('jira', 'Jira'),
  selectOptionFactory('github', 'GitHub'),
];

//  Handle setting the currently selected item in the UI
const valueToOption = (trackerType: TrackerExportType) => trackerType === 'jira'
  ? OPTIONS[0]
  : OPTIONS[1];

/**
 * UI to handle selecting which "tracker" the issue should be exported to (ie: github or jira).
 */
const ModalIssueExportTrackerPicker: FunctionComponent<ModalIssueExportTrackerPickerProps> = ({
  trackerType,
  isDisabled,
  onTrackerTypeChange,
}) => (
  <FormLabel
    label="Export to"
    htmlFor="issue-export-tracker-type"
  >
    <Select
      id="issue-export-tracker-type"
      options={OPTIONS}
      value={valueToOption(trackerType)}
      isDisabled={isDisabled}
      onChange={({ value }: SelectOption<string>) => onTrackerTypeChange(value)}
    />
  </FormLabel>
);

export default ModalIssueExportTrackerPicker;
